import { render, staticRenderFns } from "./pengobatan.vue?vue&type=template&id=b72df124&"
import script from "./pengobatan.vue?vue&type=script&lang=js&"
export * from "./pengobatan.vue?vue&type=script&lang=js&"
import style0 from "./pengobatan.vue?vue&type=style&index=0&id=b72df124&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports